<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'USERS_AND_ROLES', pageCode: 'ALL', subPageCode: 'ADD' }" class="user-management">
<p-tabView class="custom-files-tabview">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <i class="mi-lg overview"></i>
            <label class="capitalize" translate>lbl_details</label>
        </ng-template>
        <div class="user-details m-2 p-2">
            <div class="alignment-center w-full">
                <form [formGroup]="userForm">
                    <div class="card border-none p-3">
                        <h5 class="uppercase font-semibold" translate>manage_users.user_form.user_details</h5>
                        <div class="grid mb-3">                            
                            <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                                <div class="frm-label form-lbl">
                                    <label for="firstName" class="font-semibold" translate>manage_users.user_form.first_name</label><span class="text-red-500 ml-1">*</span>
                                </div>
                                <div class="frm-control">
                                    <input formControlName="firstName" class="full-width w-full custom-form" type="text" [placeholder]="'manage_users.user_form.first_name_placeholder' | translate"  pInputText id="user-first-name" autocomplete="off"/>
                                </div>
                                @if (userForm.controls.firstName.errors && (userForm.controls.firstName.dirty || userForm.controls.firstName.touched)) {
                                    <div class="form-errors">
                                        <div [hidden]="!userForm.controls.firstName.errors.required" class="text-red-500" translate>
                                            manage_users.form_error.first_name_err
                                        </div>
                                        <div [hidden]="!userForm.controls.firstName.errors.pattern" class="text-red-500" translate>
                                            manage_users.form_error.firstname_pattern_err
                                        </div>
                                        @if (userForm.controls.firstName.errors.maxlength) {
                                            <div class="text-red-500" translate>
                                                manage_users.form_error.firstname_max
                                            </div>
                                        }
                                        @if (userForm.controls.firstName.errors.minlength) {
                                            <div class="text-red-500" translate>
                                                manage_users.form_error.firstname_min
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                                <div class="frm-label form-lbl">
                                    <label for="lastName" class="font-semibold" translate>manage_users.user_form.last_name</label><span class="text-red-500 ml-1">*</span>
                                </div>
                                <div class="frm-control">
                                    <input formControlName="lastName" class="full-width w-full custom-form" type="text" [placeholder]="'manage_users.user_form.last_name_placeholder' | translate"  pInputText id="user-last-name" autocomplete="off"/>
                                </div>
                                @if (userForm.controls.lastName.errors && (userForm.controls.lastName.dirty || userForm.controls.lastName.touched)) {
                                    <div class="form-errors">
                                        <div [hidden]="!userForm.controls.lastName.errors.required" class="text-red-500" translate>
                                            manage_users.form_error.last_name_err
                                        </div>
                                        <div [hidden]="!userForm.controls.lastName.errors.pattern" class="text-red-500" translate>
                                            manage_users.form_error.lastname_pattern_err
                                        </div>
                                        @if (userForm.controls.lastName.errors.maxlength) {
                                            <div class="text-red-500" translate>
                                                manage_users.form_error.lastname_max
                                            </div>
                                        }
                                        @if (userForm.controls.lastName.errors.minlength) {
                                            <div class="text-red-500" translate>
                                                manage_users.form_error.lastname_min
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            

                            <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                                <div class="frm-label form-lbl">
                                    <label for="mobileNumber" class="font-semibold" translate>manage_users.user_form.mobile_number</label>
                                </div>
                                <div class="frm-control">
                                    <div class="flex mobile-dropdown">
                                        <p-dropdown #dropdown (onChange)="selectCountry()" [options]="countries" [(ngModel)]="selectedCountry" [filter]="true" filterBy="value" (onFilter)="onFilter($event)" [ngModelOptions]="{standalone : true}" optionLabel="name" [showClear]="false">
                                            <ng-template pTemplate="selectedItem">
                                                @if(selectedCountry) {
                                                    <div class="flex align-items-center gap-2">
                                                        <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + selectedCountry?.code?.toLowerCase()" class="width-18"/>
                                                        <div>{{ selectedCountry.value }}</div>
                                                    </div>
                                                }
                                            </ng-template>
                                            <ng-template let-country pTemplate="item">
                                                <div class="flex align-items-center gap-2">
                                                    <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + country.code.toLowerCase()" class="width-18"/>
                                                    <div>{{ country.value }}</div>
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="filtericon">
                                                <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
                                            </ng-template>
                                        </p-dropdown>
                                        <input pInputText type="text" id="user-mobile" class="w-full input-mobile" (input)="selectCountry()" formControlName="contactNumber" pKeyFilter="int" [placeholder]="'manage_users.user_form.mobile_number_placeholder' | translate"/>
                                    </div>
                                </div>
                                @if (userForm.controls.contactNumber.errors && (userForm.controls.contactNumber.dirty || userForm.controls.contactNumber.touched)) {
                                    <div class="form-errors">
                                        @if (userForm.controls.contactNumber.errors.maxlength || userForm.controls.contactNumber.errors.minlength || userForm.controls.contactNumber.errors.pattern) {
                                            <div class="text-red-500" translate>
                                                lbl_mobile_number_max_length
                                            </div>
                                        }
                                    </div>
                                }   
                            </div>
                            <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                                <div class="frm-label form-lbl">
                                    <label for="email" class="font-semibold" translate>manage_users.user_form.email_address</label><span class="text-red-500 ml-1">*</span>
                                </div>
                                <div class="frm-control">
                                    <input formControlName="email" class="full-width w-full custom-form" type="text" [placeholder]="'manage_users.user_form.email_placeholder' | translate"  pInputText id="user-email" autocomplete="off"/>
                                </div>
                                @if (userForm.controls.email.errors && (userForm.controls.email.dirty || userForm.controls.email.touched)) {
                                    <div class="form-errors">
                                        <div [hidden]="!userForm.controls.email.errors.required" class="text-red-500" translate>
                                            manage_users.form_error.email_required_err
                                        </div>
                                        <div [hidden]="!userForm.controls.email.errors.pattern" class="text-red-500" translate>
                                            manage_users.form_error.email_pattern_err
                                        </div>
                                        <div [hidden]="!userForm.controls.email.errors.emailMaxLength" class="text-red-500" translate>
                                            manage_users.form_error.email_max_length_err
                                        </div>
                                        <div [hidden]="!userForm.controls.email.errors.emailLocalPartLength" class="text-red-500" translate>
                                            manage_users.form_error.email_local_part_length_err
                                        </div>
                                    </div>
                                }
                            </div>


                            <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                                <div class="frm-label form-lbl">
                                    <label for="userEvent" class="font-semibold" translate>manage_users.columns.lbl_user_type</label><span class="text-red-500 ml-1">*</span>
                                </div>
                                <div class="frm-control">
                                    <p-dropdown #dropdown [resetFilterOnHide]="true" formControlName="userType"
                                        [options]="roleList" [placeholder]="'manage_users.user_form.select_user_role' | translate"
                                        class="multi-dropdown dropdwon full-width w-full custom-dropdown py-0" optionLabel="roleName"
                                        optionValue="roleCode" (onFilter)="onFilter($event)" (onChange)="onChangeUserType($event.value)">
                                        <ng-template pTemplate="filtericon">
                                            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
                                        </ng-template>
                                    </p-dropdown>
                                    @if (userForm.controls.userType.errors && (userForm.controls.userType.dirty || userForm.controls.userType.touched)) {
                                        <div class="form-errors mt-1">
                                            <div [hidden]="!userForm.controls.userType.errors.required" class="text-red-500" translate>
                                                manage_users.form_error.user_type_err
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                                <div class="frm-label form-lbl">
                                    <label for="username" class="font-semibold" translate>manage_users.columns.lbl_parent</label>
                                    @if (userForm.get('typeId').enabled) {
                                        <span class="text-red-500 ml-1">*</span>
                                    }
                                </div>
                                <div class="frm-control">
                                    <p-dropdown #dropdown [resetFilterOnHide]="true" [filter]="true" formControlName="typeId"
                                        [options]="parentList" id="parent" [placeholder]="'manage_users.user_form.select_parent' | translate"
                                        class="multi-dropdown dropdwon full-width w-full custom-dropdown py-0" optionLabel="label"
                                        optionValue="value" (onFilter)="onFilter($event)">
                                        <!-- <ng-template pTemplate="filtericon">
                                            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
                                        </ng-template> -->
                                    </p-dropdown>
                                    @if (userForm.controls.typeId.errors && (userForm.controls.typeId.dirty || userForm.controls.typeId.touched)) {
                                        <div class="form-errors mt-1">
                                            <div [hidden]="!userForm.controls.typeId.errors.required" class="text-red-500" translate>
                                                manage_users.form_error.parent_name_field_error
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                                <div class="frm-label form-lbl">
                                    <label for="userRole" class="font-semibold" translate>manage_users.user_form.user_role</label><span class="text-red-500 ml-1">*</span>
                                </div>
                                <div class="frm-control">
                                    @if (userForm.get('userRole').enabled){
                                        <p-dropdown #dropdown [resetFilterOnHide]="true" [filter]="true" formControlName="userRole"
                                            [options]="userRoleOption" (onChange)="getname($event)"
                                            id="user-role" [placeholder]="'manage_users.user_form.select_user_role' | translate"
                                            class="multi-dropdown dropdwon full-width w-full custom-dropdown py-0" optionLabel="label"
                                            optionValue="value" (onFilter)="onFilter($event)">
                                            <ng-template pTemplate="filtericon">
                                                <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
                                            </ng-template>
                                        </p-dropdown>
                                    } @else {
                                        <input formControlName="userRole" [placeholder]="'manage_users.user_form.select_user_role' | translate" class="w-full"  pInputText>
                                    }
                                    @if (userForm.controls.userRole.errors && (userForm.controls.userRole.dirty || userForm.controls.userRole.touched)) {
                                        <div class="form-errors mt-1">
                                            <div [hidden]="!userForm.controls.userRole.errors.required" class="text-red-500" translate>
                                                manage_users.form_error.user_role_field_error
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="flex save-button justify-content-end pt-2 mr-3 user-management">
                <button type="button" pButton [label]="'manage_users.cancel' | translate" (click)="cancelUserForm()"
                    class="mr-4 user-management border-button default-text-light-black-color cursor-pointer"
                    id="cancelBtnId"></button>
                
                <button type="button" pButton id="saveBtnId"
                    [label]="userId ? ('manage_users.update' | translate) : ('manage_users.save' | translate)"
                    (click)="saveUser()"
                    class="flex align-items-center justify-content-center cursor-pointer event-box blue-btn shadow-none"></button>
            </div>
        </div>
   </p-tabPanel>
</p-tabView>
</div>


<p-dialog [(visible)]="displayDialog" [modal]="true" [closable]="true" [responsive]="true" [style]="{width: '550px'}">
    <p-header>Confirmation</p-header>
    <div>
        <p>Are you sure you want to discard the changes?</p>
    </div>
    <p-footer>
      <button type="button" pButton label="No" (click)="onCancelDialog()" class="noChange"></button>
      <button type="button" pButton label="Discard" (click)="onConfirmCancel()" class="discard"></button>
    </p-footer>
</p-dialog>
